import PropTypes from 'prop-types';

function MMDairyAndEggsActive({ className, width }) {
    return (
        <svg width={width} viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
            <path
                d="M10.5003 3.78418L7.40472 7.34368L12.0111 8.34543L14.4129 4.63403L10.5003 3.78418Z"
                fill="#FFF9EA"
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M7.40472 7.34375C7.40472 7.34375 3.05285 26.1266 3.20475 26.3524C3.30329 26.4961 4.38715 26.763 5.42996 27.1735C6.30444 27.5225 7.62231 27.8756 7.62231 27.8756L12.0111 8.36192L7.40472 7.34375Z"
                fill="#FFF9EA"
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M12.0112 8.3623C12.0112 8.3623 18.4815 9.59397 18.58 9.78693C18.6786 9.97989 14.9877 27.9293 14.9507 28.1058C14.8481 28.6149 14.6634 28.8941 13.1566 28.7586C11.2991 28.5727 9.453 28.2862 7.62646 27.9006L12.0112 8.3623Z"
                fill="#FFF9EA"
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M12.0111 8.36198L14.4129 4.66699C14.4129 4.66699 16.9542 5.12681 17.2867 5.29103C17.6193 5.45526 18.58 9.80713 18.58 9.80713L12.0111 8.36198Z"
                fill="#FFF9EA"
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M12.0646 4.08409C12.1385 3.75975 12.3848 2.65125 12.3848 2.65125C12.3848 2.65125 12.4998 1.89994 12.9883 2.01489L15.3983 2.5363C15.3983 2.5363 16.1947 2.64304 16.0962 3.09876C15.9977 3.55447 15.6857 4.88056 15.6857 4.88056L12.0646 4.08409Z"
                fill="#FFF9EA"
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M16.941 26.3815C13.7545 24.6353 14.4468 18.3528 16.941 17.694C20.2536 16.819 23.3402 21.6097 22.1285 24.5065C21.3442 26.3815 18.8402 27.4222 16.941 26.3815Z"
                fill="#FFF9EA"
                stroke="#2D2D2D"
                strokeWidth="0.5"
            />
            <path
                d="M19.0475 21.6169C17.4614 18.3478 21.6646 13.6274 24.0794 14.5351C27.2866 15.7404 27.0279 21.4336 24.3623 23.0931C22.6369 24.1673 19.9929 23.5653 19.0475 21.6169Z"
                fill="#FFF9EA"
                stroke="#2D2D2D"
                strokeWidth="0.5"
            />
        </svg>
    );
}

export default MMDairyAndEggsActive;

MMDairyAndEggsActive.propTypes = {
    className: PropTypes.string,
    width: PropTypes.number.isRequired,
};

MMDairyAndEggsActive.defaultProps = {
    className: null,
};
